import { Box, Button, Stack, CircularProgress, useTheme } from '@mui/material';

interface ActionButtonsProps {
  onCalculatePathLoss: () => void;
  onToggleBNRadius: () => void;
  onClearRNMarker: () => void;
  onClearSectorResults?: () => void;
  sectorLoading: boolean;
  showSectorsButton: boolean;
  showRemoveButton: boolean;
  showClearButton: boolean;
  sectorsButtonLabel: string;
}

const ActionButtons = ({
  onCalculatePathLoss,
  onToggleBNRadius,
  onClearRNMarker,
  onClearSectorResults,
  sectorLoading,
  showSectorsButton,
  showRemoveButton,
  showClearButton,
  sectorsButtonLabel,
}: ActionButtonsProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        pt: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
      }}
    >
      <Stack spacing={1}>
        <Button
          variant="contained"
          fullWidth
          onClick={onCalculatePathLoss}
          disabled={sectorLoading}
          sx={{
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {sectorLoading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              Calculating...
            </>
          ) : (
            'Calculate Path Loss & Speed'
          )}
        </Button>

        {showSectorsButton && (
          <Button
            variant="outlined"
            fullWidth
            onClick={onToggleBNRadius}
            sx={{
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              '&:hover': {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
              },
            }}
          >
            {sectorsButtonLabel}
          </Button>
        )}

        {showClearButton && onClearSectorResults && (
          <Button
            variant="contained"
            fullWidth
            onClick={onClearSectorResults}
            sx={{
              backgroundColor: '#0084b4',
              '&:hover': {
                backgroundColor: '#006a8f',
              },
            }}
          >
            Clear
          </Button>
        )}

        {showRemoveButton && (
          <Button
            variant="outlined"
            fullWidth
            onClick={onClearRNMarker}
            sx={{
              borderColor: theme.palette.error.main,
              color: theme.palette.error.main,
              '&:hover': {
                borderColor: theme.palette.error.dark,
                backgroundColor: theme.palette.error.light,
              },
            }}
          >
            Remove New Pin
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ActionButtons;
